import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { LayoutComponent } from './common/layout/layout.component';
import { ForgotPasswordComponent } from './features/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { nonAuthGuard } from './core/guards/non-auth.guard';
import { authGuard } from './core/guards/auth.guard';
import { VerifyUserComponent } from './features/auth/verify-user/verify-user.component';
import { SamlValidateComponent } from './features/auth/saml-validate/saml-validate.component';

const authRoutes: Routes = [
  {
    path: 'login',
    canActivate: [nonAuthGuard],
    component: LoginComponent,
    title: 'Login',
  },
  {
    path: 'verify-user',
    canActivate: [nonAuthGuard],
    component: VerifyUserComponent,
    title: 'Verify User',
  },
  {
    path: 'forgot-password',
    canActivate: [nonAuthGuard],
    component: ForgotPasswordComponent,
    title: 'Forgot Password',
  },
  {
    path: 'reset-password',
    canActivate: [nonAuthGuard],
    component: ResetPasswordComponent,
    title: 'Reset Password',
  },
  {
    path: 'samlvalidate',
    component: SamlValidateComponent,
    title: 'SAML Validate',
  },
];

const applicationRoutes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    component: LayoutComponent,
    loadChildren: () => import('./routes/main.routes').then(m => m.mainRoutes),
  },
];

export const routes: Routes = [
  ...authRoutes,
  ...applicationRoutes,
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
